/**
 * @chineseName 进度条
 * @subDescription m-ui组件 进度条
 */
import Progress from './progress';
export default Progress;